<template>
    <div class="community_wrap">
        <!-- 第一页背景图片 -->
        <div class="top_bgimg">
            <div class="img_title">MaxSwell 数据科学社区</div>
            <div class="img_parsing">建立开放的数据交流分享平台，扩大各种数据来源，及时完善补充数据资料，不断丰富数据品种，实现不同类型用户之间数据的高效流通。</div>
        </div>

        <div class="community_content">
            <!-- tab栏 -->
            <div class="project_tab">
                <ul>
                    <li v-for="item in subNav" :key="item.id" :class="{ active: isactive == item.id }" @click="changeTab(item.id)">{{item.title}}</li>
                </ul>
            </div>
            <div class="flex-between">
                <!-- 搜索框 -->
                <div class="project_serch">
                    <el-input placeholder="请输入搜索内容" v-model="searchKey" class="project_input"  @keyup.enter.native='getCommunityData'>
                        <el-button slot="suffix" round  type="primary" @click="getCommunityData">搜索</el-button>
                    </el-input>
                </div>
                <div class="flex-center">
                    <!-- 排序 -->
                    <div class="selection">
                        <span>排序</span>
                        <el-select placeholder="请选择" v-model="sortMode" @change="getCommunityData">
                            <el-option v-for="item in sortContent" :key="item.id" :label="item.label" :value="item.id"> </el-option>
                        </el-select>
                    </div>
                    <!-- 内容分享 -->
                    <div class="ml20">
                        <el-button type="primary" @click="$router.push(`/communityShare`)">内容分享</el-button>
                    </div>
                </div>
            </div>

            <!-- 文章模块 -->
            <div class="passage_father_box">
                <!-- 单个模块 -->
                <div v-for="item in communityList" :key="item.id" class="passage" @click="enterCommunityDetail(item.id)">
                    <div class="img_wrap" :style="`background:url(${item.imageUrl}) 0 0/100% 100% no-repeat`"></div>
                    <div class="passage_content">
                        <div class="title">{{item.title}}</div>
                        <div class="summary">{{item.summary}}</div>
                        <div class="user">
                            <div class="flex-center">
                                <el-avatar :size="25" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
                                <p class="passage_source ml10">{{item.username}}</p>
                            </div>

                        </div>
                    </div>
                    <div class="item_button">
                        <div>{{item.createTime}}</div>
                        <div class="icon_wrap flex-between">
                            <i class="el-icon-view">&nbsp;&nbsp;&nbsp;{{item.browseNum}}</i>
                            <i class="el-icon-download">&nbsp;&nbsp;&nbsp;{{item.downloadNum}}</i>
                        </div>
                    </div>
                </div>
                <div class="page_wrap">
                    <el-pagination  layout="prev, pager, next" :page-size="3"  @current-change="getCommunityData" :current-page.sync="pages.currentPage" :total="pages.total"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { communitySearch, field } from '../../../utils/api';

export default {
    data() {
        return {
            filterList:[],
            sortMode:0,
            sortContent:[{
                id:0,
                label:'最新发布'
            },{
                id:1,
                label:'浏览量最多'
            }],
            subNav:[{
                id:0,
                title:'全部'
            },{
                id:1,
                title:'源数据'
            },{
                id:2,
                title:'源代码'
            },{
                id:4,
                title:'分析报告'
            }],
            communityList:[],
            pages:{
                currentPage:1,
                total:10
            },
            searchKey:'',
            classData: '',
            isactive: 0
        };
    },
    created() {
        this.getCommunityData()
    },
    methods: {
        //公共数据全选
        allFilter(){
            this.filterList = []
            this.pages.currentPage = 1
            this.getCommunityData()
        },

        //获取社区数据
        getCommunityData(){
            let params = {
                fieldTypes:this.filterList,
                keyword:this.searchKey,
                page:this.pages.currentPage,
                size:3,
                type:this.isactive,
                sort:this.sortMode
            }
            communitySearch(params).then(res => {
                this.communityList = res.data.list;
                this.pages.total = res.data.totalCount;
            }).catch(err=>{})
        },

        //更改导航栏
        changeTab(id){
            this.isactive = id
            this.pages.currentPage = 1
            if(id == 3){
                field().then(res => {
                    this.publicList = res.data;
                }).catch(err=>{})
            }
            this.getCommunityData()
        },

        //查看社区细节
        enterCommunityDetail(id){
            this.$router.push({path:'/communityDetail',
            query:{
                id,
                source:2
            }})
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/.el-checkbox-button__inner{
    background: #F5F5F5;
    margin-bottom: 20px;
}
/deep/.el-pagination .btn-prev{
    background: none;
}
/deep/.el-pagination .btn-next{
    background: none;
}
/deep/ .number{
    font-size: 22px;
    font-weight: 50;
    color: #909399;
    background: none;
}
.community_wrap {
    position: relative;
    .top_bgimg {
        background: url('../../../assets/img/bg-01.png') 0 0/100% 100% no-repeat;
        height: 570px;
        width: 100%;
        color: #5277f7;
        position: relative;
        .img_title {
            font-size: 50px;
            font-family: PingFang SC;
            font-weight: bold;
            line-height: 56px;
            position: absolute;
            top: 190px;
            left: 130px;
        }
        .img_parsing {
            font-size: 22px;
            font-family: PingFang SC;
            line-height: 30px;
            position: absolute;
            width: 37%;
            line-height: 1.8;
            top: 280px;
            left: 130px;
        }
    }
    .community_content {
        width: calc(100% - 400px);
        margin-left: 200px;
        position: relative;

        .project_tab {
            width: 100%;
            height: 74px;
            border: 2px solid #5277f7;
            border-radius: 20px;
            position: relative;
            top: -50px;
            background: white;
            // margin: 0px 0px ;
            ul {
                width: 80%;
                height: 100%;
                margin-left: calc(20% / 2);
                display: flex;
                justify-content: space-between;
                align-items: center;
                text-align: center;
                li {
                    display: block;
                    height: 93%;
                    width: 120px;
                    float: right;
                    font-size: 22px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    line-height: 30px;
                    color: #3c3c3c;
                    line-height: 74px;
                }
                li:hover{
                    cursor: pointer;
                    font-size: 25px;
                }
            }
        }
        .project_serch {
            width: 250px;
            .el-button{
              position: relative;
              left: 5px;
            }
            /deep/ .el-input__inner {
                border-radius: 70px !important;
            }
            .serch_btn {
                width: 60px;
                background: #5277f7;
                border-radius: 20px;
                span {
                    line-height: 40px;
                    color: #fcfcff;
                    // font-size: 20px;
                }
            }
            .serch_btn:hover{
                cursor: pointer;
                opacity: 0.8;
            }
        }
        .selection {
            width: 270px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            span {
                margin-right: 10px;
                color: #5277f7;
            }
        }
        .passage_father_box {
            margin-top: 20px;
            width: 100%;
            .passage {
                padding: 20px 20px;
                background: #fcfcff;
                height: 220px;
                display: flex;
                margin-bottom: 30px;
                .img_wrap{
                    width: 15%;
                }
                .passage_content{
                    width: 73%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    box-sizing: border-box;
                    padding: 10px 40px;
                    .title{
                        font-size: 22px;
                        color: #5278F7 ;
                        font-weight: 600;
                    }
                    .summary{
                        font-size: 18px;
                        line-height: 1.7;
                         color: rgba(33,33,33,0.6);
                    }
                    .user{
                        display: flex;
                        align-items: center;
                        color: #5278F7;
                        img{
                            width: 50px;
                            margin-right: 20px;
                        }
                    }
                }
                .item_button {
                    width: 13%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-end;
                    box-sizing: border-box;
                    padding: 20px 20px 0px 0px;
                    .icon_wrap{
                        width: 100%;
                    }
                    i {
                        font-size: 18px;
                        font-family: PingFang SC;
                        font-weight: 400;
                        line-height: 20px;
                    }
                }
            }
            .passage:hover{
                cursor: pointer;
                background: #f3f3f3;
                opacity: 0.8;
            }
            .page_wrap {
                margin-top: 20px;
                height: 60px;
                line-height: 60px;
                text-align: center;
            }
        }
    }
}

.active {
    // background: darkcyan;
    border-bottom: 5px solid #5277f7;
    font-size: 25px;
}
/deep/.el-pagination .btn-prev {
    background: none;
}
/deep/.el-pagination .btn-next {
    background: none;
}
/deep/ .number {
    font-size: 22px;
    font-weight: 50;
    color: #909399;
    background: none;
}
</style>
